import { __makeTemplateObject } from './../../../external/tslib/tslib.es6.js';
import styled, { css } from 'styled-components';
import { renderTextVariations } from '../utils/renderTextVariations.js';

var OverlineLg = styled.span(function (_a) {
    var _b = _a.type, type = _b === void 0 ? 'default' : _b, bold = _a.bold, overlineLg = _a.theme.olist.components.text.overlineLg;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      ", "\n    "], ["\n      ", "\n    "])), renderTextVariations(overlineLg, type, bold));
});
var templateObject_1;

export { OverlineLg as default };
